import * as React from 'react'
import * as classnames from 'classnames'

import * as styles from './fullWidthBannerBlock.module.css'

import { ICategoryPageBlockComponent } from '../../../../typings/pageBlocks'
import { reportBlockClick } from '../../../../common/analytics/homePageAnalytics'
import { getPageTypeFromLocation } from '../../../../common/utils/location/getPageTypeFromUrl'

interface IFullWidthBannerBlockData {
  title: string
  subtitle: string
  buttonText: string
  image: {
    url: string
    alt: string
  }
  url: string
  backgroundColor: string
  textColor: string
  gaLabel: string
}

interface IProps extends ICategoryPageBlockComponent {
  data: IFullWidthBannerBlockData
  onBannerClick?: () => void
  logoRight?: boolean
}

const onBannerClickHandler = (gaLabel: string, pageType?: string) => () => {
  if (pageType && gaLabel) {
    reportBlockClick(`${pageType}Page banner`, {
      eventLabel: gaLabel,
      dimension19: 'body',
      eventAction: 'click;banner'
    })
  }
}

const FullWidthBannerBlock = ({
  location,
  currentSite,
  data,
  logoRight
}: IProps) => {
  const {
    title,
    subtitle,
    buttonText,
    image,
    backgroundColor,
    textColor,
    url,
    gaLabel
  } = data

  const pageType = getPageTypeFromLocation(location, currentSite)

  const classes = classnames({
    [styles.logoRight]: logoRight,
    [styles.limitWidth]: pageType === 'home'
  })

  const bannerStyles = {
    backgroundColor,
    color: textColor
  }

  const buttonStyles = {
    backgroundColor: textColor,
    color: backgroundColor
  }

  return (
    <article className={classes}>
      <a
        href={url}
        style={bannerStyles}
        className={styles.banner}
        onClick={onBannerClickHandler(gaLabel, pageType)}
      >
        <div className={styles.imageWrapper}>
          <img className={styles.image} src={image.url} alt={image.alt} />
        </div>
        <div className={styles.detail}>
          <header>
            <h2 className={styles.title}>{title}</h2>
            <h3 className={styles.subtitle}>{subtitle}</h3>
          </header>

          <button style={buttonStyles} className={styles.button}>
            {buttonText}
          </button>
        </div>
      </a>
    </article>
  )
}

export default FullWidthBannerBlock
